export default __webpack_public_path__ + "static/media/moot-court-9.8df53235.webp";